import AccountRepository from '@/shared/http/repositories/access/account'
import NotificationGroupRepository from '@/shared/http/repositories/access/notificationgroup'
import actionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import notificationgroupmodel from '@/shared/models/access/notificationgroupmodel'
import notificationgroupForm from './notificationgroup-form'

export default {
  name: 'NotificationsGroups',
  mixins: [actionsForm],
  data () {
    return {
      data: notificationgroupmodel,
      form: notificationgroupForm,
      objList: [],
      accountList: [],
      newAccount: {}
    }
  },
  methods: {
    onLoad () {
      this.onClear()

      loading.push()
      AccountRepository.GetAll()
        .then(response => {
          if (response.data.code > 0) {
            this.accountList = response.data.data
            this.filterAccount()
          }
        })
        .then(() => {
          NotificationGroupRepository.GetAll()
            .then(response => {
              if (response.data.code > 0) {
                this.objList = response.data.data
              } else {
                toast.error(response.data.message)
              }
            })
            .catch(err => {
              this.onException(err)
            })
        })
        .finally(() => loading.close())
    },
    onEditForm (obj) {
      this.onEdit(obj)
      this.filterAccount()
    },
    onClearForm () {
      this.onClear()
      this.filterAccount()
    },
    onCreate () {
      loading.push()
      this.data.tipo = 1
      NotificationGroupRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.objList.push(response.data.data)
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdate () {
      loading.push()
      NotificationGroupRepository.Update(this.data)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            const idx = this.objList.map(n => n.id).indexOf(response.data.data.id)
            this.objList.splice(idx, 1, response.data.data)
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onDelete (item) {
      loading.push()
      NotificationGroupRepository.Delete(item.id)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            const idx = this.objList.map(n => n.id).indexOf(item.id)
            this.objList.splice(idx, 1)
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onSelectAccount (item) {
      if (item) {
        if (!this.form.contas.value) {
          this.form.contas.value = []
        }
        const list = this.form.contas.value
        list.push({
          id: '00000000-0000-0000-0000-000000000000',
          contaID: item,
          grupoNotificacaoID: this.data.id || '00000000-0000-0000-0000-000000000000'
        })
        list.sort((a, b) => {
          const nomeA = this.accountList.filter(c => c.id === a.contaID)[0].nome
          const nomeB = this.accountList.filter(c => c.id === b.contaID)[0].nome
          return nomeA < nomeB ? -1 : nomeB < nomeA ? 1 : 0
        })
        this.$set(this.form.contas.value, list)
        this.newAccount = {}
        this.filterAccount()
      }
    },
    onRemoveAccount (item) {
      this.form.contas.value = this.form.contas.value.filter(c => c.contaID !== item.contaID)
      this.filterAccount()
    },
    getName (id) {
      const account = this.accountList.filter(l => l.id === id)[0]
      return account ? account.nome : 'N/A'
    },
    filterAccount () {
      this.form.contas.options = (this.accountList
        ? this.accountList.filter(c => {
          return !this.form.contas.value || !this.form.contas.value.some(v => v.contaID === c.id)
        })
        : [])
        .map(data => {
          const result = {text: data.nome, value: data.id}
          return result
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/notificationgroups/notificationgroups.js